import { Tooltip, Box, Button, Skeleton } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import SubdirectoryArrowRightOutlinedIcon from '@mui/icons-material/SubdirectoryArrowRightOutlined';
import { Edit } from '@mui/icons-material';
import StatusCell from './StatusCell';
import { SupportAgentOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';

export default function SalesBillOfMaterialGrid({
  parentRow,
  parentIndex,
  isPricingLoading,
  setSelectedEditItem,
  setIsSalesBOMItem,
  setIsSupportTicket,
}) {
  return (
    <DataGridPro
      rows={parentRow.salesBillOfMaterialItems}
      columns={[
        {
          field: 'spacer',
          width: 40,
          renderCell: () => (
            <Box
              sx={{
                display: 'flex',
                height: '88%',
                alignItems: 'center',
              }}
            >
              <SubdirectoryArrowRightOutlinedIcon
                sx={{ ml: 1, color: 'gray' }}
                fontSize="small"
              />
            </Box>
          ),
        },
        { field: 'title', flex: 1 },
        {
          field: 'pricingDate',
          width: 160,
          type: 'date',
          valueFormatter: (value) =>
            value ? dayjs(value).format('DD.MM.YYYY') : null,
        },
        // {
        //   field: 'endDate',
        //   width: 90,
        // },
        {
          field: 'displayQuantity',
          width: 70,
          type: 'number',
          disableColumnMenu: true,
        },
        {
          field: 'unitPrice',
          width: 100,
          type: 'number',
        },
        {
          field: 'discountPercentage',
          width: 80,
          type: 'number',
          renderCell: (params) => {
            if (isPricingLoading && params.row.articleId) {
              return <Skeleton width="100%" />;
            }
            return params.value === 0
              ? ''
              : params.value?.toLocaleString('de-DE', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                });
          },
        },
        {
          field: 'totalPrice',
          width: 100,
          type: 'number',
        },
        {
          field: 'status',
          headerName: 'Status',
          width: 54,
          align: 'center',
          renderCell: ({ value }) => <StatusCell value={value} />,
        },
        {
          field: 'edit',
          align: 'center',
          width: 54,
          renderCell: ({ row: subRow }) => {
            const subIndex = parentRow.salesBillOfMaterialItems.findIndex(
              (si) => si.uuid === subRow.uuid,
            );
            return (
              <Tooltip title={'Position bearbeiten'}>
                <span>
                  <Button
                    size="small"
                    sx={{ minWidth: '32px' }}
                    onClick={() => {
                      setSelectedEditItem({ parentIndex, subIndex });
                      setIsSalesBOMItem(true);
                      setIsSupportTicket(false);
                    }}
                  >
                    <Edit
                      sx={{
                        fontSize: '18px',
                        color: 'text.secondary',
                      }}
                    />
                  </Button>
                </span>
              </Tooltip>
            );
          },
        },
        {
          field: 'support',
          headerName: '',
          width: 54,
          align: 'center',
          renderCell: ({ row: subRow }) => {
            const subIndex = parentRow.salesBillOfMaterialItems.findIndex(
              (si) => si.uuid === subRow.uuid,
            );
            return (
              <Tooltip
                title={
                  'Ticket für die Unterposition der Verkaufsstückliste erstellen'
                }
              >
                <span>
                  <Button
                    size="small"
                    sx={{ minWidth: '32px' }}
                    onClick={() => {
                      setSelectedEditItem({ parentIndex, subIndex });
                      setIsSalesBOMItem(true);
                      setIsSupportTicket(true);
                    }}
                  >
                    <SupportAgentOutlined
                      sx={{
                        color: 'text.secondary',
                      }}
                    />
                  </Button>
                </span>
              </Tooltip>
            );
          },
        },
      ]}
      autoHeight
      hideFooter
      disableRowSelectionOnClick
      rowReordering
      sx={{
        '.MuiDataGrid-rowReorderCell': {
          display: 'none',
        },
        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
          outline: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
          display: 'none',
        },
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: 'none',
      }}
    />
  );
}
